import { render } from "./notice.vue?vue&type=template&id=28c905a9&scoped=true&ts=true"
import script from "./notice.vue?vue&type=script&lang=ts"
export * from "./notice.vue?vue&type=script&lang=ts"

import "./notice.vue?vue&type=style&index=0&id=28c905a9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c905a9"]])

export default __exports__